module.exports = __webpack_public_path__ + "static/media/PlugInToYourClerks_ShortVideo_1605277258235.f84d2173.docx";